function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.203 14.8c-.2.2.2 2.499-1.2 5.998 0 0 3.2 0 5.1-1.4 1.8-1.5 2.3-4.399 2.3-4.399-4.5.6-6-.4-6.2-.2zM.003 6.4c-.1-3.299 2.5-5.998 5.8-6.098l11.7-.3c3.3-.1 6 2.5 6.1 5.798l.2 7.799c.1 5.498-4.2 10.097-9.7 10.197l-7.7.2c-3.3.1-6-2.5-6.1-5.798L.003 6.4zM20.803 12l-.2-6.099c0-1.6-1.4-2.899-3-2.899l-11.8.3c-1.6 0-2.9 1.4-2.9 3l.3 11.797c0 1.6 1.4 2.899 3 2.899l3.8-.1c2-5.299.6-8.198 1.8-9.198 1.3-.9 2.7 1.3 9 .3z",
  fillRule: "nonzero",
  fill: "#000"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;